import { h } from 'preact';
import PropTypes from 'prop-types';

import Cta from '../../2-atoms/cta/cta';

const SkyItTabsButton = ({ title, onClick, active, icon, index }) => (
  <button
    type="button"
    className="c-sky-it-tabs__button"
    onClick={() => onClick(index)}
    data-state={active ? 'active' : 'inactive'}
    disabled={active}
  >
    {icon}
    <Cta modifiers={['secondary-on-dark-no-outline']}>{title}</Cta>
  </button>
);

SkyItTabsButton.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  icon: PropTypes.any,
  onClick: PropTypes.func,
  index: PropTypes.number,
};

export default SkyItTabsButton;
